const $ = require("../../lib/jquery");

let ciudadActual = "";
const googleDomain = "https://www.google.com/maps/embed?pb=";

const romaQuery =
  "!1m18!1m12!1m3!1d2969.4653256470533!2d12.48846971594762!3d41.90435457922018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61a976b79a35%3A0x7c5135f5052073d1!2sViajes+El+Corte+Ingles!5e0!3m2!1ses!2ses!4v1513872805533";
const milanoQuery =
  "!1m18!1m12!1m3!1d2798.4392388023102!2d9.18836021603385!3d45.460955079100856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6a91015a593%3A0x14c52979fd17bdbd!2sVia+Alberico+Albricci%2C+9%2C+20122+Milano+MI%2C+Italia!5e0!3m2!1ses!2ses!4v1513873032370";

function changeLocationMap(e) {
  const ciudad = e.data ? e.data.q : e;
  if (ciudadActual !== ciudad) {
    ciudadActual = ciudad;
    $("div[id='map_field'] iframe").attr("src", googleDomain + ciudadActual);
  }
}

$("a[title='Roma']").click({ q: romaQuery }, changeLocationMap);
$("a[title='Milano']").click({ q: milanoQuery }, changeLocationMap);
$(() => changeLocationMap(romaQuery));
